import {
  GET_MICRO_LOANS_SETTINGS_ERROR,
  GET_MICRO_LOANS_SETTINGS_START,
  GET_MICRO_LOANS_SETTINGS_SUCCESS,
} from 'constants/action-types/settings/getMicroLoansSettingData';
import apiAction from 'helpers/apiAction';

export default queries => dispatch =>
  dispatch(
    apiAction({
      url: '/groups/microloans/settings/overview',
      method: 'GET',
      queries,
      API_REQUEST_START: GET_MICRO_LOANS_SETTINGS_START,
      API_REQUEST_SUCCESS: GET_MICRO_LOANS_SETTINGS_SUCCESS,
      API_REQUEST_FAILURE: GET_MICRO_LOANS_SETTINGS_ERROR,
      onSuccess: payload => {
        dispatch({
          type: GET_MICRO_LOANS_SETTINGS_SUCCESS,
          payload: payload?.data,
        });
      },
      onEnd: () => false,
    }),
  );
